import { render, staticRenderFns } from "./deduct.vue?vue&type=template&id=5e875399&scoped=true&"
import script from "./deduct.vue?vue&type=script&lang=js&"
export * from "./deduct.vue?vue&type=script&lang=js&"
import style0 from "./deduct.vue?vue&type=style&index=0&id=5e875399&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e875399",
  null
  
)

export default component.exports